import i18n from 'l10n';
import Handlebars from 'handlebars';
import GenericView from 'js/views/generic.view';
import GroupModel from 'js/models/group.model';
import GroupsCollection from 'js/models/groups.collection';
import InnerView from 'js/views/subscriber.group.tile.view';
import Template from 'js/templates/subscriber.groups.tiles.hbs';
import {el, on, tagName, template} from "../adapters/backbone-decorators";
import {_} from "backboneAdapter";

@el("#group-memberships-container")
@tagName('span')
@template(Template)
class SubscriberGroupsTilesView extends GenericView {

    constructor(options) {
        super(options);
        this.options = options;
        this.inSubscriberInGroupsSearch = false;
        this.subscriberInGroupsLength = 0;
        this.GroupView = InnerView;

        this.groupsCollection = new GroupsCollection();

        $(this.collection).each((index, model) => {
            this.groupsCollection.add(new GroupModel(model));
        });

        this.loadQueryGroupsData();
    }

    hide() {
        this.$el.parent().parent().hide();
    }

    show() {
        this.$el.parent().parent().show();
    }

    renderCollection(callback) {
        if (!this.inSubscriberInGroupsSearch) {
            this.subscriberInGroupsLength = this.groupsCollection.length;
        }
        var isSubscriberInGroups = this.subscriberInGroupsLength !== 0;
        var tempTemplate = Handlebars.compile(Template)({
            "length": this.groupsCollection.length,
            "isSubscriberInGroups": isSubscriberInGroups
        });

        var groupIds = [];
        this.groupsCollection.each(model => groupIds.push(model.get("id")));

        if (groupIds.length > 0) {
            $.ajaxDefaultQ({
                url: "/CampaignCloud/Group/blockedCount",
                type: 'GET',
                contentType: 'application/json',
                traditional: true,
                data: {groupIds},
                dataType: 'json'
            }).done(data => {
                this.$el.html(tempTemplate);

                this.blockedCount = data;
                _.forEach(this.blockedCount, tuple => {
                    const model = _.find(this.groupsCollection.models, model => model.get(model.idAttribute) === tuple[0]);
                    if (model) {
                        model.set("blockedCount", tuple[1]);
                    }
                });
                this.groupsCollection.each(model => this.renderModel(model));

                this.$('[data-i18n]').i18n();
            });
            $.ajaxDefaultQ({
                url: "/CampaignCloud/Group/emailBounced",
                type: 'GET',
                contentType: 'application/json',
                traditional: true,
                data: {groupIds: groupIds},
                dataType: 'json'
            }).done(data => {
                this.$el.html(tempTemplate);

                this.emailBounced = data;
                _.forEach(this.emailBounced, tuple => {
                    const model = _.find(this.groupsCollection.models, model => model.get(model.idAttribute) === tuple[0]);
                    if (model) {
                        model.set("emailBounced", tuple[1]);
                    }
                });

                $.ajaxDefaultQ({
                    url: "/CampaignCloud/Group/smsBounced",
                    type: 'GET',
                    contentType: 'application/json',
                    traditional: true,
                    data: {groupIds: groupIds},
                    dataType: 'json'
                }).done(data => {

                    this.smsBounced = data;
                    _.forEach(this.smsBounced, tuple => {
                        const model = this.groupsCollection.find(model => model.get(model.idAttribute) === tuple[0]);
                        if (model) {
                            model.set("smsBounced", tuple[1]);
                        }
                    });
                    this.groupsCollection.each(model => this.renderModel(model));

                    this.$('[data-i18n]').i18n();
                });
            });
        } else {
            this.$el.html(tempTemplate);
            this.groupsCollection.each(model => this.renderModel(model));

            this.$('[data-i18n]').i18n();
        }
    }

    renderModel(model, scroll) {
        var view = new this.GroupView({
            model: model,
            contactModel: this.options.contactModel,
            groupsCount: [this.options.groupsCount, this.$el.find(".groups-count")]
        });
        view.render();
        var el = view.el;
        this.$el.find('#grouptiles').append(el);
        if (scroll) {
            el.scrollIntoView();
        }
    }

    @on('keyup .searchbox')
    dosearch() {
        var self = this;
        var text = self.$el.find('.searchbox').val().toLowerCase();
        if (text.length > 0) {
            var searchresults = _.filter(this.groupsCollection.models, m => m.myText().indexOf(text) !== -1);

            for (var i = 0; i < this.groupsCollection.models.length; i++) {
                var model = this.groupsCollection.models[i];
                if (searchresults.indexOf(this.groupsCollection.models[i]) !== -1) {
                    self.$el.find(`#group-${model.get("id")}`).show();
                } else {
                    self.$el.find(`#group-${model.get("id")}`).hide();
                }
            }
            this.inSubscriberInGroupsSearch = true;
            $(".groups-count").text(i18n.t("outOf", {
                n: searchresults.length,
                m: this.groupsCollection.models.length
            }));
        } else {
            this.inSubscriberInGroupsSearch = false;
            self.$el.find('.tile').show();
            $(".groups-count").text(this.groupsCollection.models.length);
        }
    }

    loadQueryGroupsData() {
        //find and fill groups Sizes, for Message report pages
        var self = this;
        var queryGroups = [];

        self.groupsCollection.each(function (model) {
            if (model.get("groupType") === "query") {
                queryGroups.push([model.get(model.idAttribute), model.get("query")]);
            }
        });

        if (queryGroups.length !== 0) {
            var queryCountDeferred = function LoadQueryCount() {
                return $.ajaxDefaultQ({
                    url: "/CampaignCloud/Subscription/CountByCriterion/many",
                    type: 'POST',
                    contentType: 'application/json',
                    dataType: 'json',
                    data: JSON.stringify(queryGroups)
                });
            };

            $.when(queryCountDeferred()).then(function (queryCountData) {
                if (queryCountData) {
                    queryCountData.forEach(function (queryGroup) {
                        self.groupsCollection.find(function (model) {
                            return model.get("id") === parseInt(queryGroup[0]);
                        }).set("size", queryGroup[1]);
                        $("#group-" + queryGroup[0] + " #size-contact").text(queryGroup[1]);
                    });
                }
            });
        }
    }
}

export default SubscriberGroupsTilesView;
